export default __webpack_public_path__ + "static/media/6.dfea17d0.jpg";